import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';

import './style.scss';

const TRANSLATION_KEY = 'Microcentrifuge.string';

export function Heading(props) {
  const {t} = useTranslation();

  return <div className='mc_tooltip_heading'>{t(TRANSLATION_KEY)}</div>;
}

Heading.propTypes = {};
